module.exports = __webpack_public_path__ + "media/images/favicon-b7f6ebbf707d6382494824241836ea3e.ico";